// Sugalarm — cycle 468: the OWNER's grace banner (phone + web).
//
// "Your Sugar Alarm grace period ends <date>. Reactivate in the app to keep
// alarms running." Shown only while enforcement is in force for this account
// and the account is in grace (`graceBannerVisible`); it renders NOTHING
// during a live alarm or a No Data alarm (the cycle-464 rule) and never on
// the kiosk (its read-only card carries the same date). In flow at the top of
// the route content — no portal, no overlay, no z-index — so it can never
// cover an alarm control. The whole strip is the one control: it opens
// Settings → Subscription.

import { useNavigate } from "react-router-dom";

import type { Subscription } from "../../api/subscription";
import type { BillingPlatform } from "../../lib/billing";
import { graceBannerLine, graceBannerVisible } from "../../lib/serviceLock";
import styles from "./GraceBanner.module.css";

export interface GraceBannerProps {
  subscription: Subscription | null;
  alarmLive: boolean;
  noDataAlarmActive: boolean;
  platform: BillingPlatform;
}

export function GraceBanner({ subscription, alarmLive, noDataAlarmActive, platform }: GraceBannerProps) {
  const nav = useNavigate();
  if (!graceBannerVisible({ sub: subscription, alarmLive, noDataAlarmActive, platform })) return null;
  const line = graceBannerLine(subscription?.grace_ends_at);
  if (!line) return null;
  return (
    <button
      type="button"
      className={styles.root}
      data-testid="grace-banner"
      onClick={() => nav("/settings?section=subscription")}
    >
      <span className={styles.line}>{line}</span>
      <span className={styles.cta}>Reactivate</span>
    </button>
  );
}
